const SAFE_HTML = Symbol('safeHtml');

type SafeHtml = { readonly [SAFE_HTML]: true; readonly value: string };

function escapeHtml(value: string) {
  return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function isSafeHtml(value: unknown): value is SafeHtml {
  return typeof value === 'object' && value !== null && SAFE_HTML in value;
}

function toHtml(value: unknown): string {
  if (isSafeHtml(value)) {
    return value.value;
  }

  if (Array.isArray(value)) {
    return value.map(toHtml).join('');
  }

  return escapeHtml(String(value ?? ''));
}

export function html(strings: TemplateStringsArray, ...values: unknown[]): SafeHtml {
  const value = strings.reduce((output, part, index) => output + part + toHtml(values[index]), '');

  return { [SAFE_HTML]: true, value };
}

export function toHtmlString(safeHtml: SafeHtml) {
  return safeHtml.value;
}
